module.exports = __webpack_public_path__ + "static/img/3.babe109.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/qiye/202000408/3.png
// module id = MK2/
// module chunks = 1